const BASE_URL = '/api/collections/news/entries';

export default (initPage = 1) => ({
  news: [],
  query: '',
  locale: '',
  loaded: false,
  pagination: null,
  page: 1,

  filter() {
    fetch(
      BASE_URL +
        `?filter[site]=${this.locale}&filter[title:contains]=${this.query}&sort=-date&limit=18&page=${this.page}`
    )
      .then((response) => response.json())
      .then((response) => {
        this.news = response.data;
        this.pagination = response.meta;
        this.loaded = true;
      });
  },

  changePage(newPage) {
    this.page = newPage;
    let currentUrl = window.location.href;
    let url = new URL(currentUrl);

    url.searchParams.set('page', newPage);
    window.history.pushState({}, '', url);

    window.scrollTo(0, 0);
    this.filter();
  },

  init() {
    this.locale = document.documentElement.lang;
    this.page = initPage;
    this.filter();
  },
});
